/* eslint-disable no-use-before-define */
import React from 'react'
import useScatterGraph from './use-scatter-graph'
import { arrayFrom, } from '../../twd/twd'

export default () => {
    const {
        selectedBenchmarks, benchmarksData,
        // top5Tickers, selectedTop5Tickers,
        // customTickers, selectedCustomTickers,
        // tickersData,
    } = useScatterGraph()

    return <React.Fragment>
        { benchmarksTable(selectedBenchmarks, benchmarksData)}
    </React.Fragment>
}

let benchmarksTable = (selected, data) => {
    let years = [1,2,3,5,7,10,20,30]
    return <React.Fragment>
        <table>
        <caption>Yield curves benchmarks.</caption>
        <tbody>
        <tr>
        <th scope="col">Benchmark</th>
        {
            years.map( (a, i) => <th key={i} scope="col">{a} year</th>)
        }
        </tr>
        {
            selected.map( (bench, i) => {
                return <tr key={i}>
                    <td>{bench}</td>
                    {
                        years.map( (year, i) => {
                            return <td key={i}>{ findYield(data, bench, year)}</td>
                        })
                    }
                </tr>
            })
        }
        </tbody>
        </table>
    </React.Fragment>

}

let findYield = (data, key, year) => {
    let a = data[key]
    if (!a) return '-'
    return arrayFrom(a)
        .filter( i => i.maturityYearValue===year)
        .map(i => i.yieldValue)[0] || '-'
}


// WEBPACK FOOTER //
// ./src/corporates/scatter-graph/table.js